import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-play--hero",
  "use": "icon-play--hero-usage",
  "viewBox": "0 0 42 42",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 42 42\" id=\"icon-play--hero\"><rect x=\".5\" y=\".5\" width=\"41\" height=\"41\" rx=\"1.5\" fill=\"#fff\" fill-opacity=\".2\" /><rect x=\".5\" y=\".5\" width=\"41\" height=\"41\" rx=\"1.5\" stroke=\"#fff\" /><path d=\"M26.5 20.134a1 1 0 0 1 0 1.732l-7.5 4.33a1 1 0 0 1-1.5-.866v-8.66a1 1 0 0 1 1.5-.866l7.5 4.33Z\" fill=\"#fff\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol